import jwt_decode from 'jwt-decode';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { FranchiseUserInfo } from '../../models/models';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../providers/auth/auth-service.service';
import { AppConsts } from '../../app-consts';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  userInfo: FranchiseUserInfo = {};
  @Input('currentLang') currentLang: string | null;
  language: any;
  activeUserMenu: any;
  activeMenu: any;
  constructor(private router: Router, private oAuthService: OAuthService, private authService: AuthService, private activatedRouter: ActivatedRoute, public translate: TranslateService,
    private _oauthService: OAuthService) {

    const token: string | null = sessionStorage.getItem(AppConsts.Session_AccessToken);
    if (!token) {
      this._oauthService.events.subscribe((res: { type: any }) => {

        switch (res.type) {
          case "token_received":
            if (!this.userInfo.userName || this.userInfo.userName.length <= 0)
              this.setUserInfo();
            break;
          default:
            break;
        }
      });
    }
    else {
      this.setUserInfo();

    }

  }

  setUserInfo() {
    try {

      const token: string | null = sessionStorage.getItem(AppConsts.Session_AccessToken);
      if (token && token.length > 0) {
        this.userInfo = jwt_decode<FranchiseUserInfo>(token);
        if (this.currentLang === 'ar') {
          this.userInfo.userName = this.userInfo.firstNameAr + ' ' + this.userInfo.lastNameAr
        }
        else {
          if (this.userInfo.firstNameEn && this.userInfo.firstNameEn.length > 0 && this.userInfo.lastNameEn && this.userInfo.lastNameEn.length > 0)
            this.userInfo.userName = this.userInfo.firstNameEn + ' ' + this.userInfo.lastNameEn
          else
            this.userInfo.userName = this.userInfo.firstNameAr + ' ' + this.userInfo.lastNameAr
        }
      }
    }
    catch {
    }
  }


  ngOnInit() {
  }

  isActiveRoute(path: any): boolean {
    return this.router.url.includes(path);
  }

  createNewFranchise() {
    this.currentLang = sessionStorage.getItem(AppConsts.Session_Lang);
    let url = this.currentLang + '/franchise-creation';
    this.router.navigate([url]);
  }

  // navigateTo(path: string): void {
  //   this.currentLang = sessionStorage.getItem("lang");
  //   let url = this.currentLang + path;
  //   this.router.navigate([url]);
  // }

  switchLanguage() {
    if (this.currentLang) {
      if (this.currentLang === "ar") {
        sessionStorage.setItem(AppConsts.Session_Lang, 'en');
        let url = this.router.url.replace(this.currentLang, 'en')
        window.location.replace(url)
      } else if (this.currentLang === "en") {
        sessionStorage.setItem(AppConsts.Session_Lang, 'ar');
        let url = this.router.url.replace(this.currentLang, 'ar')
        window.location.replace(url)
      }
    }
  }

  logout() {
    //sessionStorage.removeItem("IsMonshaat");
    this.oAuthService.logOut();
    // this.authService.logout().subscribe(res => {
    //   this.oAuthService.logOut(true);
    //   this.router.navigate(['/'+this.currentLang]);
    // });
  }
}
